import { Close, Left, Right } from '@icon-park/react'
import style from './index.module.less'
import React, {KeyboardEventHandler, useRef, useState} from 'react';
import {Button, Input} from 'antd';
import {getImagePathWithTheme, imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import i18next from 'i18next';


const SearchBox = () => {
  /** 搜索词 */
  const [v, setV] = useState<string>("");
  /**替换词 */
  const [rs, setRs] = useState<string>("")
  /** 当前 */
  const [i, setI] = useState<number>(0)
  /** 总数 */
  const [t, setT] = useState<number>(0)
  /**展示 */
  const [show, setShow] = useState<boolean>(false)
  /** 类型：0 搜索 1 替换 */
  const [type, setType] = useState<0 | 1>(0)

  const inputSearchRef = useRef(null);


  window.GSearchOpen = (szValue='',focus=false) => {
    szValue = szValue.trim();
    setV(szValue)
    setI(0)
    setRs('')
    setType(0)
    setShow(true)
    if (!isStringNullOrEmpty(szValue)){
      setTimeout(()=>{
        updateSearchReplace(szValue);
      },10)
    }
    if (focus){
      setTimeout(()=>{
        inputSearchRef.current?.focus();
      },300)
    }
  }
  const GSearchClose = () => {
    updateSearchReplace('')
    setTimeout(() => {
      setShow(false)
    }, 100)
  }

  window.GSearchClose = GSearchClose

  const jump = (right = false, focus = true, to=undefined) => {
    let c = right ? i + 1 : i - 1
    if (c === 0) c = t
    if (c > t) c = 1
    if (to) {
      c = to
    }
    setI(c)

    window.GEditor.commands.jumpSearchTerm(c-1)
  }

  const updateSearchReplace = (v) => {
    setI(0)
    setV(v)
    window.GEditor.commands.setSearchTerm(v);
    const el = document.querySelectorAll('.search-result') || []
    setT(el.length)
    if (el.length) {
      setI(0)
      setTimeout(() => {
        jump(true, false, 1)
      }, 50)
    }
  };
  if (!show) return null


  function replace() {
    window.GEditor.commands.replace(i - 1)
    setT((s) => {
      let tt = s,
          ii = i;
      if (s === 1) {
        tt = 0
        ii = 0
      } else {
        tt = s - 1
        if (ii > tt) {
          ii = tt
        }
      }
      setI(ii)
      window.GEditor.commands.jumpSearchTerm(ii - 1)

      return tt
    })
  }

  function replaceAll() {

    window.GEditor.commands.replaceAll()
    updateSearchReplace(v)
  }

  function setReplaceTerm(str: string) {
    setRs(str)
    window.GEditor.commands.setReplaceTerm(str)
  }

  return (
    <div className={style.SearchBoxStyle+ ' default-font-size'}>
      <div className={style.top}>
        <span>
          <span className={!type && style.act} style={{borderBottom:type?'0px solid #444444':'2px solid #444444',cursor:'pointer'}} onClick={() => setType(0)}>{i18next.t('Search')}</span>
          <span style={{marginLeft:'12px',borderBottom:type?'2px solid #444444':'0px solid #444444',cursor:'pointer'}}  onClick={() => setType(1)} className={!!type && style.act}>{i18next.t("Replace")}</span>
        </span>
        {/*<span className='dialog-title'>Search</span>*/}
        <img className='img-mini-small-10 cursor-pointer' src={getImagePathWithTheme('close_black')} onClick={GSearchClose}/>
      </div>
      <div style={{background: '#9999991A', height: '1px', margin: '6px 0'}}></div>
      <div className={style.bottom}>
        <div className={style.input + ' input-border-5f'}>
          <Input ref={inputSearchRef} value={v} variant={'borderless'}
                 onChange={(e) => updateSearchReplace(e.target.value)} autoFocus onKeyDown={(e: any) => {
            if (e.keyCode === 13 && t) {
              jump(true)
            }
            e.stopPropagation();
          }} />
          {
              v &&
              <div style={{position:"absolute",right:'12px',bottom:'6px'}} className={style.action + ' flex-row-vertical-center'}>
                <Left style={{display:t?'inherit':'none'}} theme="outline" size="12" fill="#333" onClick={() => jump()} />
                <span className='font-size-12'>{t ? i + '/' + t : i18next.t('No found')}</span>
                <Right style={{display:t?'inherit':'none'}} theme="outline" size="12" fill="#333" onClick={() => jump(true)} />
              </div>

          }
        </div>

        {
            !!type &&
            <div className={style.searchReplace} style={{width:'100%'}}>
              <div>
                <span>{i18next.t("Replace with")}</span>
                <Input className='input-border-5f' variant={'borderless'} value={rs} onChange={(e) => setReplaceTerm(e.target.value)} placeholder='' />
              </div>
              <div className={style.action}>
                <Button className={'button-border-gray-style'} style={{color:'var(--text-color)',border:'1px solid var(--input-border-color-1)'}} onClick={replaceAll} disabled={!t}>{i18next.t("Replace All")}</Button>
                <Button disabled={!t} className={'button-border-gray-style'} style={{color:'var(--text-color)',border:'1px solid var(--input-border-color-1)'}} onClick={replace}>{i18next.t("Replace")}</Button>
              </div>
            </div>
        }
      </div>
    </div>
  )
}
export default SearchBox



























































